import { SliceCaseReducers } from '@reduxjs/toolkit'
import { ApiResponse, createOperationSlice, GenericOperationState } from '@repo/core'
import { CommunicationsData } from '@repo/mailbox-types'
import { CommunicationsFilters } from '@repo/shared-types'

const initialState: GenericOperationState<ApiResponse<CommunicationsData> | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: communicationsDataActions, reducer: communicationsDataReducers } =
  createOperationSlice<
    ApiResponse<CommunicationsData> | null,
    SliceCaseReducers<GenericOperationState<ApiResponse<CommunicationsData> | null>>,
    CommunicationsFilters | undefined
  >({
    name: '@mailbox/communications/data',
    initialState,
    reducers: {},
  })
